module.exports = __webpack_public_path__ + "img/TVUPack1.54f694d4.png";